export default __webpack_public_path__ + "static/media/people-821624_960_720.fa6ce82a.jpg";